import React from 'react';
import { KbCategory } from '../callCenterKnowledgeBaseTypes';
import styles from './CategoryGrid.module.css';

interface CategoryGridProps {
  categories: KbCategory[];
  selected?: string | null;
  onSelect?: (categoryName: string) => void;
}

export const CategoryGrid: React.FC<CategoryGridProps> = ({ categories, selected, onSelect }) => {
  return (
    <div className={styles.grid}>
      {categories.map((cat) => {
        const isActive = selected === cat.name;
        return (
          <button
            key={cat.id}
            type="button"
            className={styles.card}
            onClick={() => onSelect?.(cat.name)}
            style={isActive ? { borderColor: '#2563EB', background: '#EFF6FF' } : undefined}
            aria-pressed={isActive}
          >
            <span className={styles.iconBox}>
              <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6z" />
              </svg>
            </span>
            <span className={styles.name}>{cat.name}</span>
            <span className={styles.count}>{cat.articleCount} Articles</span>
          </button>
        );
      })}
    </div>
  );
};
